/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component, ElementRef, TemplateRef } from '@angular/core';
import { INoRowsOverlayParams } from 'ag-grid-community';
import { GridNoRowsOverlayComponent } from '../../cell-components';

@Component({
  selector: 'gh-grid-no-rows-overlay-template',
  template: '<ng-container [ngTemplateOutlet]="templateRef"></ng-container>',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridNoRowsOverlayTemplateComponent implements GridNoRowsOverlayComponent {
  templateRef: TemplateRef<any>;

  constructor(private elementRef: ElementRef) {
  }

  agInit(params: INoRowsOverlayParams): void {
    this.templateRef = params['templateRef'];
  }

  getGui(): HTMLElement {
    return this.elementRef.nativeElement;
  }
}
